import "./src/apple.svg";
import "./src/anchor.svg";
import "./src/anchor-loader.svg";
import "./src/arowhead-s.svg";
import "./src/arw-head-s.svg";
import "./src/arw-w.svg";
import "./src/attention--triangle.svg";
import "./src/bell.svg";
import "./src/burger.svg";
import "./src/cafe.svg";
import "./src/calendar.svg";
import "./src/card--default.svg";
import "./src/card--mastercard.svg";
import "./src/card--mir.svg";
import "./src/card--visa.svg";
import "./src/check.svg";
import "./src/clock--circle.svg";
import "./src/cross--circle.svg";
import "./src/cross--light.svg";
import "./src/cross.svg";
import "./src/divider.svg";
import "./src/exclamation--circle.svg";
import "./src/exit.svg";
import "./src/forum-colorful.svg";
import "./src/forum.svg";
import "./src/heart-colorful--full--hover.svg";
import "./src/heart-colorful--full.svg";
import "./src/heart-colorful.svg";
import "./src/heart-empty.svg";
import "./src/house.svg";
import "./src/info.svg";
import "./src/letter.svg";
import "./src/logo_fuse8.svg";
import "./src/loup.svg";
import "./src/no-result.svg";
import "./src/pencil--contured.svg";
import "./src/pencil-contured--colorful.svg";
import "./src/pensil.svg";
import "./src/person-colorful.svg";
import "./src/person.svg";
import "./src/phone--colorful.svg";
import "./src/phone.svg";
import "./src/plus--light.svg";
import "./src/plus.svg";
import "./src/points-vertical.svg";
import "./src/purse.svg";
import "./src/sheet.svg";
import "./src/smile.svg";
import "./src/star--empty.svg";
import "./src/star--filled.svg";
import "./src/success.svg";
import "./src/tick--circle.svg";
import "./src/ticket.svg";
import "./src/wheel.svg";
import "./src/logosber.svg";

import "./icons-sprite-themed.replaceable";



// WEBPACK FOOTER //
// ./application/components/dumb/icon/icons-sprite.js